/**
 * Class Modal Librairy
 */

export default class Modal {

  constructor() {
    this.modals = Array.from(document.querySelectorAll('.modal'));
    // Check if modal exist
    if(this.modals) {
      let dataTriggers = Array.from(document.querySelectorAll('[data-toggle="modal"]'));
      let dataClose = Array.from(document.querySelectorAll('[data-dismiss="modal"]'));
      // Check if there is triggers
      if(dataTriggers) {
        dataTriggers.forEach(e => {
          // Add listener and toggle the modal on click
          e.addEventListener('click', e => {
            this._setCurrentTrigger(e.currentTarget);
            const targetId = this.lastTrigger.getAttribute('data-target');
            // Add new hash to history
            //history.pushState(null, null, '#'+ targetId);
            const target = document.getElementById(targetId);
            this.open(target);
          });
        });
      }
      // Check if there is close buttons
      if(dataClose) {
        dataClose.forEach(e => {
          e.addEventListener('click', this.close.bind(this));
        });
      }
      // Check if url change
      window.addEventListener('hashchange',this._openByHash.bind(this));
      // Check if modal is open on load
      window.addEventListener('load',this._openByHash.bind(this));
    }
  }

  /**
   * Open the selected modal
   * @method open
   * @param {Object} targetedModal - Modal node
   *
   */
  open(targetedModal) {
    // Fast click doesn't call this function
    if(document.querySelector('.js-is--open')) {
      return false;
    }
    // Check is targetedModal is a HTML Element
    if(targetedModal instanceof HTMLElement) {
      this.lastModal = targetedModal;
    }

    // Check is targetedModal is a string
    else if(typeof targetedModal === 'string') {
      this.lastModal = document.getElementById(targetedModal);
    }

    // Assign modal to lastModal
    // Check if the modal exist
    if(this.lastModal) {
      // Build and append overlay
      const overlay = this._buildOverlay();
      this._openOverlay(overlay)

      if(this.lastTrigger) {
        // Check if the button trigger an ajax modal
        if(this.lastTrigger.hasAttribute('data-fetch-url')) {
          // Attention!! Async Function.
          this._fetchContent(this.lastTrigger.getAttribute('data-fetch-url'))
          this._setFetchModalSize();
        }
      }

      // Show the modal
      setTimeout(() => this.lastModal.classList.add('js-is--animated') ,20);
      this.lastModal.classList.add('js-is--open')

      // Remove the scroll from the body -> allow the modal to scroll instead
      document.body.classList.add('js-is--modal-open');
    }
    else {
      throw new Error("The targeted modal doesn't exist")
    }
  }


  /**
   * Close the first modal
   * @method close
   */
  close() {
    this._closeOverlay();
    // Reset body scroll
    // Modal
    this._afterTransitionModalListener = this._afterTransitionModal.bind(this);
    this.lastModal.addEventListener('transitionend',this._afterTransitionModalListener);
    this.lastModal.classList.remove('js-is--animated');
  }

   /**
   * Close the first modal
   * @method _fetchContent
   */
  _fetchContent(url){
    fetch(url)
      .then((resp) => resp.text())
      .then((text) => {
          //Transform text to node and extract body
          this.lastModal.appendChild(new DOMParser().parseFromString(text,'text/html').body);
          this.lastModal.setAttribute('aria-describedby',this.lastModal.querySelector('.modal__title').id);
        }
      )
      .catch((error) => {
        // console.log('Error with' +  url + ': \n', error);
      });
  }


  /**
   * Set this.lastTrigger
   * @protected
   * @method _setCurrentTrigger
   */
  _setCurrentTrigger(trigger) {
    this.lastTrigger = trigger;
  }

  /**
   * Load a modal by Hash/Id name
   * @protected
   * @method _openByHash
   */
  _openByHash() {
    const hash = window.location.hash.substring(1);
    let target;

    if(window.location.hash.length > 1) {
      target = document.getElementById(hash);
    }
    // Get id in url and remove #
    // Search the ID

    // Check if the node exist
    if(target) {
      // Check ff this node is a modal
      if(target.classList.contains('modal')) {
        //open a new modal
        this.open(target);
      }
    }
  }


  /**
   * Set correct size to the ajax modal
   * @protected
   * @method _setFetchModalSize
   */
  _setFetchModalSize() {
    if(this.lastTrigger.hasAttribute('data-modal-size')) {
      this.lastModal.classList.add('modal--' + this.lastTrigger.getAttribute('data-modal-size'));
    }
  }

  /**
   * Get scrollbar width
   * @protected
   * @method _getScrollBarWidth
   * @return {number} scrollbar width
   */
  _getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  /**
   * Build a new overlay
   * @protected
   * @method _buildOverlay
   * @return {Object} overlay
   */

  _buildOverlay() {
    const checkOverlay = document.querySelector('.modal__overlay');
    // Avoid double overlay
    if(!checkOverlay) {
      const overlay = document.createElement('div');
      overlay.classList.add('modal__overlay')
      overlay.addEventListener('click', this.close.bind(this));
      document.body.style.paddingRight = this._getScrollbarWidth() + 'px';
      return document.body.appendChild(overlay);
    }
  }


  /**
   * Show overlay
   * @protected
   * @method _openOverlay
   * @param {node} overlay
   */

  _openOverlay(overlay) {
    overlay.classList.add('js-is--animated');
  }


  /**
   * Close overlay
   * @protected
   * @method _closeOverlay
   */

  _closeOverlay() {
    // Prevent double click
    // If body has this class this is not a double click
    if(!document.body.classList.contains('js-is--modal-open')) {
      return false;
    }

    const overlay = document.querySelector('.modal__overlay');
    // On transitionend remove the overlay
    overlay.addEventListener('transitionend',() => {
      overlay.classList.remove('modal__overlay');
      overlay.parentNode.removeChild(overlay);
    })
    overlay.classList.remove('js-is--animated');
  }


  /**
   * Launch after the modal transition
   * @protected
   * @method _afterTransitionModal
   */

  _afterTransitionModal() {
    if(this.lastTrigger){

      if(this.lastTrigger.hasAttribute('data-fetch-url')) {
        this.lastModal.removeChild(this.lastModal.lastChild);
      }

      if(this.lastTrigger.hasAttribute('data-fetch-url')){
        this.lastModal.classList.remove('modal--sm','modal--md','modal--lg');
      }
      //reset lastTrigger
      this.lastTrigger = null;
    }

    this.lastModal.classList.remove('js-is--open');
    this.lastModal.removeEventListener('transitionend',this._afterTransitionModalListener);
    this.lastModal.removeAttribute('aria-describedby');



    this.lastModal = null;
    document.body.style.paddingRight = null;
    document.body.classList.remove('js-is--modal-open');
  }
}

